import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Check } from "lucide-react";
import { api, waLink, fmtDate, altaMsg, recogidaTomatisMsg, devolucionTomatisMsg } from "@/lib/api";
import { useCentro } from "@/lib/centro";
import { recordatorioMsg } from "@/components/ApptDialog";

const TIPO = {
  cita: { label: "Cita de mañana", cls: "bg-sky-100 text-sky-800" },
  devolucion: { label: "Devolver Tomatis", cls: "bg-violet-100 text-violet-800" },
  recogida: { label: "Recoger Tomatis", cls: "bg-violet-50 text-violet-700" },
  alta: { label: "Revisión de alta", cls: "bg-purple-100 text-purple-800" },
};

const mensaje = (w) => {
  if (w.tipo === "cita") return recordatorioMsg(w.appt, w.prof);
  if (w.tipo === "devolucion") return devolucionTomatisMsg(w.patient.nombre, w.ciclo, w.fecha);
  if (w.tipo === "recogida") return recogidaTomatisMsg(w.patient.nombre, w.ciclo, w.fecha);
  return altaMsg(w.patient, w.rev);
};

const marcar = (w) => {
  if (w.tipo === "cita") return api.post(`/appointments/${w.appt.id}/recordado`);
  if (w.tipo === "alta") return api.post(`/altas/${w.alta_id}/revisiones/${w.rev.id}/wa`);
  return api.post(`/tomatis-devices/aviso-recogida/${w.tid}`, { ciclo: w.ciclo, avisado: true, tipo: w.tipo });
};

const detalle = (w) => (w.tipo === "cita" ? `${fmtDate(w.fecha)} · ${w.appt.inicio}` : w.tipo === "alta" ? `${w.rev.etiqueta} · ${fmtDate(w.fecha)}${w.rev.no_vino ? " · no vino" : ""}` : `${w.aparato} · ciclo ${w.ciclo} · ${fmtDate(w.fecha)}`);
const enlace = (w) => (w.tipo === "cita" ? "/agenda" : w.tipo === "alta" ? "/altas" : `/tratamiento/${w.tid}`);

const Fila = ({ w, i, hecho, onEnviar }) => (
  <div className="flex flex-wrap items-center gap-x-3 gap-y-1 py-2 text-sm" data-testid={`wa-hoy-${i}`}>
    <span className={`rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase ${TIPO[w.tipo].cls}`}>{TIPO[w.tipo].label}</span>
    <Link to={enlace(w)} className="flex-1 min-w-[160px] truncate text-slate-800 hover:underline">{w.patient.nombre}</Link>
    <span className="text-xs text-slate-500">{detalle(w)}</span>
    {hecho ? <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-emerald-700" data-testid={`wa-hoy-hecho-${i}`}><Check className="h-3.5 w-3.5" />Enviado</span>
      : <button type="button" onClick={() => onEnviar(w)} data-testid={`wa-hoy-btn-${i}`} className="rounded bg-[#25D366] px-2.5 py-1 text-[11px] font-medium text-white hover:opacity-90">WhatsApp</button>}
  </div>
);

export const WaHoy = () => {
  const { centro } = useCentro();
  const [list, setList] = useState(null);
  const [hechos, setHechos] = useState([]);
  const load = useCallback(() => {
    api.get("/wa-hoy", { params: { centro } }).then((r) => { setList(r.data); setHechos([]); });
  }, [centro]);
  useEffect(() => {
    load();
  }, [load]);
  if (!list?.length) return null;
  const cola = list.filter((w) => !hechos.includes(w.key));
  const enviar = (w) => {
    window.open(waLink(w.patient.telefono, mensaje(w)), "_blank");
    setHechos((h) => [...h, w.key]);
    marcar(w);
  };
  return (
    <div className="mb-8 bg-white border border-emerald-200 rounded-lg p-4 fade-up" data-testid="wa-hoy">
      <div className="flex flex-wrap items-center gap-2 mb-1">
        <MessageCircle className="h-4 w-4 text-[#25D366]" />
        <h3 className="text-sm font-semibold text-slate-800">WhatsApp que tocan hoy</h3>
        <span className="text-xs text-slate-500" data-testid="wa-hoy-count">{cola.length} por enviar de {list.length}</span>
        {cola[0] && <button type="button" onClick={() => enviar(cola[0])} data-testid="wa-hoy-siguiente" className="ml-auto rounded-md bg-[#25D366] px-3 py-1 text-xs font-medium text-white">Enviar el siguiente: {cola[0].patient.nombre.split(" ")[0]}</button>}
        {!cola.length && <button type="button" onClick={load} data-testid="wa-hoy-recargar" className="ml-auto text-xs underline text-slate-500">Actualizar</button>}
      </div>
      <p className="text-[11px] text-slate-400 mb-1">Se abre vuestro WhatsApp con el mensaje escrito: lo enviáis, volvéis aquí y pulsáis el siguiente. Cada uno queda marcado como enviado.</p>
      <div className="divide-y divide-slate-100">{list.map((w, i) => <Fila key={w.key} w={w} i={i} hecho={hechos.includes(w.key)} onEnviar={enviar} />)}</div>
    </div>
  );
};
